var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"search"}},[_c('el-form',[_c('el-button',{attrs:{"native-type":"submit","icon":"el-icon-search"}}),_c('el-input',{attrs:{"name":"q","placeholder":"ricerca ..."},model:{value:(_vm.q),callback:function ($$v) {_vm.q=$$v},expression:"q"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }